import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardContainerComponent } from './card-container.component';
import { FormatDateModule } from '@go-modules/pipes/format-date/format-date.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormatDateModule
	],
	declarations: [
		CardContainerComponent
	],
	exports: [
		CardContainerComponent
	]
})
export class CardContainerModule {}
